var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 43,
    width: 280,
    height: 263,
    rx: 20,
    stroke: "#EA3377",
    strokeWidth: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 80,
    width: 192,
    height: 63,
    rx: 5,
    stroke: "#EA3377",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 112L153 112",
    stroke: "#FF3131",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188 112L208 112",
    stroke: "#93E54B",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243 112L263 112",
    stroke: "#68ADE5",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 167,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#EA3377"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 231,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#EA3377"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 167,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#EA3377"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 231,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#EA3377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257 177C257 171.477 261.477 167 267 167H292C297.523 167 302 171.477 302 177V266C302 271.523 297.523 276 292 276H267C261.477 276 257 271.523 257 266V177Z",
    fill: "#EA3377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.a364ef0be25e6c8df2ad62f9021a50b8.svg";
export { ForwardRef as ReactComponent };